"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommandC2D = exports.commands = exports.OtaDeviceManageCommand = exports.OtaDeviceManageParams = exports.OtaTargetVersion = exports.OtaBuildFile = exports.OTA_MEMORY_REGIONS = exports.SetTapTypeAppCommand = exports.SetLocationAliasCommand = exports.ResetCommand = exports.ResetComponent = exports.PurgeCommand = exports.PurgeAction = exports.PurgeComponent = exports.FlushCommand = exports.FlushAction = exports.FlushComponent = exports.CalibrateCommand = exports.CalibrateAction = exports.CalibrateComponent = exports.RestartCommand = exports.RestartComponent = void 0;
const effect_1 = require("effect");
const SemVer = __importStar(require("../../../../semver"));
const common_1 = require("./common");
const RoutineSequence = __importStar(require("./routine-sequence"));
const NAMESPACE = 'Culligan.Device.Class.HydroTapBridge.Command';
exports.RestartComponent = RoutineSequence.Component.pipe(effect_1.Schema.pickLiteral('lcd')).annotations({
    identifier: `${NAMESPACE}.RestartComponent`,
});
class RestartCommand extends effect_1.Schema.Class(`${NAMESPACE}.RestartCommand`)({
    command: effect_1.Schema.tag('restart'),
    params: effect_1.Schema.Struct({
        component: exports.RestartComponent,
    }),
}, {
    identifier: `${NAMESPACE}.RestartCommand`,
    title: 'Restart Command',
    description: 'Instructs the device to restart the specified component',
}) {
}
exports.RestartCommand = RestartCommand;
exports.CalibrateComponent = RoutineSequence.Component.pipe(effect_1.Schema.pickLiteral('boiling', 'light')).annotations({
    identifier: `${NAMESPACE}.CalibrateComponent`,
});
exports.CalibrateAction = RoutineSequence.Action.pipe(effect_1.Schema.pickLiteral('info', 'start', 'exit')).annotations({
    identifier: `${NAMESPACE}.CalibrateAction`,
});
class CalibrateCommand extends effect_1.Schema.Class(`${NAMESPACE}.CalibrateCommand`)({
    command: effect_1.Schema.tag('calibrate'),
    params: effect_1.Schema.Struct({
        component: exports.CalibrateComponent,
        action: exports.CalibrateAction,
    }),
}, {
    identifier: `${NAMESPACE}.CalibrateCommand`,
    title: 'Calibrate Command',
    description: 'Instructs the device to start calibrating the specified component',
}) {
}
exports.CalibrateCommand = CalibrateCommand;
exports.FlushComponent = RoutineSequence.Component.pipe(effect_1.Schema.pickLiteral('tank', 'filter')).annotations({
    identifier: `${NAMESPACE}.FlushComponent`,
});
exports.FlushAction = RoutineSequence.Action.pipe(effect_1.Schema.pickLiteral('info', 'preRun', 'start', 'pause', 'resume', 'finish', 'exit')).annotations({
    identifier: `${NAMESPACE}.FlushAction`,
});
class FlushCommand extends effect_1.Schema.Class(`${NAMESPACE}.FlushCommand`)({
    command: effect_1.Schema.tag('flush'),
    params: effect_1.Schema.Struct({
        component: exports.FlushComponent,
        action: exports.FlushAction,
    }),
}, {
    identifier: `${NAMESPACE}.FlushCommand`,
    title: 'Flush Command',
    description: 'Instructs the device to start flushing the specified component',
}) {
}
exports.FlushCommand = FlushCommand;
exports.PurgeComponent = RoutineSequence.Component.pipe(effect_1.Schema.pickLiteral('co2')).annotations({
    identifier: `${NAMESPACE}.PurgeComponent`,
});
exports.PurgeAction = RoutineSequence.Action.pipe(effect_1.Schema.pickLiteral('info', 'start', 'pause', 'resume', 'finish', 'exit')).annotations({
    identifier: `${NAMESPACE}.PurgeAction`,
});
class PurgeCommand extends effect_1.Schema.Class(`${NAMESPACE}.PurgeCommand`)({
    command: effect_1.Schema.tag('purge'),
    params: effect_1.Schema.Struct({
        component: exports.PurgeComponent,
        action: exports.PurgeAction,
    }),
}, {
    identifier: `${NAMESPACE}.PurgeCommand`,
    title: 'Purge Command',
    description: 'Instructs the device to start purging the specified component',
}) {
}
exports.PurgeCommand = PurgeCommand;
exports.ResetComponent = RoutineSequence.Component.pipe(effect_1.Schema.pickLiteral('filter_counter', 'co2_counter', 'energy_usage', 'co2_sensor_zero_flow')).annotations({
    identifier: `${NAMESPACE}.ResetComponent`,
});
class ResetCommand extends effect_1.Schema.Class(`${NAMESPACE}.ResetCommand`)({
    command: effect_1.Schema.tag('reset'),
    params: effect_1.Schema.Struct({
        component: exports.ResetComponent,
    }),
}, {
    identifier: `${NAMESPACE}.ResetCommand`,
    title: 'Reset Command',
    description: 'Instructs the device to reset the specified component',
}) {
}
exports.ResetCommand = ResetCommand;
class SetLocationAliasCommand extends effect_1.Schema.Class(`${NAMESPACE}.SetLocationAliasCommand`)({
    command: effect_1.Schema.tag('location_alias.set'),
    params: effect_1.Schema.Struct({
        locationAlias: common_1.LocationAlias,
    }),
}, {
    identifier: `${NAMESPACE}.SetLocationAliasCommand`,
    title: 'Set Location Alias',
    description: 'Instructs the device to set its location alias to the given value',
}) {
}
exports.SetLocationAliasCommand = SetLocationAliasCommand;
class SetTapTypeAppCommand extends effect_1.Schema.Class(`${NAMESPACE}.SetTapTypeAppCommand`)({
    command: effect_1.Schema.tag('tap_type_app.set'),
    params: effect_1.Schema.Struct({
        tapTypeApp: common_1.TapTypeApp,
    }),
}, {
    identifier: `${NAMESPACE}.SetTapTypeAppCommand`,
    title: 'Set Tap Application Type',
    description: 'Instructs the device to set the tap application type to the given value',
}) {
}
exports.SetTapTypeAppCommand = SetTapTypeAppCommand;
exports.OTA_MEMORY_REGIONS = ['Wifi', 'Core', 'Gfx'];
exports.OtaBuildFile = effect_1.Schema.NullOr(effect_1.Schema.NonEmptyString).annotations({
    identifier: `${NAMESPACE}.OtaBuildFile`,
    description: 'The file name of the build artifact to flash to a memory region, ' +
        'or null to leave the region out of this update',
});
exports.OtaTargetVersion = effect_1.Schema.NullOr(SemVer.SemVer).annotations({
    identifier: `${NAMESPACE}.OtaTargetVersion`,
    description: 'The version the memory region should end up on, ' +
        'or null to leave the region out of this update',
});
exports.OtaDeviceManageParams = effect_1.Schema.Struct({
    buildFileWifi: exports.OtaBuildFile,
    targetVersionWifi: exports.OtaTargetVersion,
    buildFileCore: exports.OtaBuildFile,
    targetVersionCore: exports.OtaTargetVersion,
    buildFileGfx: exports.OtaBuildFile,
    targetVersionGfx: exports.OtaTargetVersion,
    forceTargetVersion: effect_1.Schema.propertySignature(effect_1.Schema.Boolean).annotations({
        description: 'When true the device flashes the requested target version even if a later build ' +
            'artifact exists, which is what makes a rollback possible. When false the device ' +
            'uses the later artifact instead',
    }),
})
    .pipe(effect_1.Schema.filter(params => {
    // A region is either fully specified or left out entirely: the device has no way to
    // resolve one half of the pair on its own.
    const unpaired = exports.OTA_MEMORY_REGIONS.filter(region => (params[`buildFile${region}`] === null) !== (params[`targetVersion${region}`] === null));
    if (unpaired.length > 0) {
        return `${unpaired.join(', ')}: a build file and a target version must both be given, or both be null`;
    }
    // Every region left out means "check all three and take whatever is newer", which is the
    // opposite of forcing a specific version.
    const noRegionRequested = exports.OTA_MEMORY_REGIONS.every(region => params[`buildFile${region}`] === null);
    if (noRegionRequested && params.forceTargetVersion) {
        return 'forceTargetVersion requires at least one memory region to be specified';
    }
    return undefined;
}))
    .annotations({
    identifier: `${NAMESPACE}.OtaDeviceManageParams`,
    description: 'The memory regions to update. Leaving every region null asks the device to check all ' +
        'three and update the ones with a later build artifact',
});
class OtaDeviceManageCommand extends effect_1.Schema.Class(`${NAMESPACE}.OtaDeviceManageCommand`)({
    command: effect_1.Schema.tag('ota.device_manage'),
    params: exports.OtaDeviceManageParams,
}, {
    identifier: `${NAMESPACE}.OtaDeviceManageCommand`,
    title: 'Device Managed OTA Update',
    description: 'Instructs the device to trigger and manage OTA updates across its three memory regions. ' +
        'The device sequences the individual updates itself, including the power cycles between ' +
        'them, so the cloud is only a gateway for this command',
}) {
}
exports.OtaDeviceManageCommand = OtaDeviceManageCommand;
exports.commands = [
    RestartCommand,
    CalibrateCommand,
    FlushCommand,
    PurgeCommand,
    ResetCommand,
    SetLocationAliasCommand,
    SetTapTypeAppCommand,
    OtaDeviceManageCommand,
];
exports.CommandC2D = effect_1.Schema.Union(...exports.commands).annotations({
    identifier: `${NAMESPACE}.CommandC2D`,
});
//# sourceMappingURL=command.js.map